"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chiliPiperBookingFormSchema = void 0;

var _yup = require("yup");

var CHILI_PIPER_LINK_REGEXP = /^https:\/\/[a-z0-9-.]+\.chilipiper\.com\/book\/me\/[a-z0-9-.]+$/i;
var chiliPiperBookingLinkSchema = (0, _yup.string)().required('Please enter a booking link.').matches(CHILI_PIPER_LINK_REGEXP, {
  message: 'Please ensure the booking link is correctly copied, as the current format appears to be incorrect.'
}).default('');
var chiliPiperBookingFormSchema = (0, _yup.object)().shape({
  bookingLink: chiliPiperBookingLinkSchema
});
exports.chiliPiperBookingFormSchema = chiliPiperBookingFormSchema;